import type { StatusTone } from 'core/theme.tokens'

export function muiChipColorToStatusTone(
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
): StatusTone {
  switch (color) {
    case 'success':
      return 'success'
    case 'error':
      return 'danger'
    case 'warning':
      return 'warning'
    case 'info':
    case 'primary':
      return 'info'
    case 'secondary':
      return 'purple'
    default:
      return 'neutral'
  }
}

export function transportTruckStatusTone(status?: string): StatusTone {
  const value = (status ?? '').trim().toLowerCase()
  if (value === 'delivered' || value === 'completed') return 'success'
  if (value === 'in_transit') return 'inProgress'
  if (value === 'assigned' || value === 'awaiting_transport') return 'waiting'
  if (value === 'repair') return 'danger'
  if (value === 'draft') return 'neutral'
  return 'neutral'
}

export function legStatusTone(status?: string): StatusTone {
  const normalized = (status ?? '').trim().toLowerCase()
  if (normalized === 'completed') return 'success'
  if (normalized === 'in progress' || normalized === 'in_progress') return 'inProgress'
  if (normalized === 'assigned') return 'info'
  if (normalized === 'draft') return 'neutral'
  return 'neutral'
}

export function logisticsUserStatusTone(status?: string): StatusTone {
  const normalized = (status ?? 'ACTIVE').trim().toUpperCase()
  if (normalized === 'ACTIVE') return 'success'
  if (normalized === 'INACTIVE' || normalized === 'DISABLED') return 'neutral'
  if (normalized === 'PENDING') return 'waiting'
  return 'neutral'
}

export function inventoryListingStatusTone(status?: string): StatusTone {
  const normalized = (status ?? '').trim().toLowerCase()
  if (normalized.includes('sold')) return 'danger'
  if (normalized.includes('pending') || normalized.includes('deal')) return 'warning'
  if (normalized.includes('active')) return 'info'
  return 'neutral'
}

export function transportReadyLaneTone(label: string): StatusTone {
  if (label === 'Not ready') return 'neutral'
  if (label.includes('Customer') && label.includes('Repair')) return 'purple'
  if (label.includes('Repair')) return 'danger'
  if (label.includes('Customer')) return 'info'
  return 'waiting'
}

export function checklistAnswerTone(answer?: string): StatusTone {
  if (answer === 'yes') return 'success'
  if (answer === 'no') return 'danger'
  if (answer === 'na') return 'neutral'
  return 'warning'
}
